<img
  ngClass="ball ball--{{ ball() }}"
  [class.ball--large]="large()"
  [ngSrc]="large() ? 'img/balls-56.avif' : 'img/balls-42.avif'"
  [width]="large() ? 224 : 168"
  [height]="large() ? 280 : 210"
  [alt]="alt()"
/>
